import styled from 'styled-components';
import getContrastFontColor from '@utils/getContrastFontColor';

export const StyledToggleButton = styled.div`
  button span,
  button span::before,
  button span::after {
    background: ${({ theme }) =>
      getContrastFontColor(
        theme.customColors.header,
        theme.defaultColors.fontPrimary,
        theme.defaultColors.lighterGrey
      )};
  }
`;
